import AppDispatcher from '../dispatcher/AppDispatcher';

export const GET_ALL_VERIFICATION = 'GET_ALL_VERIFICATION';
export const GET_ALL_VERIFICATION_SUCCESS = 'GET_ALL_VERIFICATION_SUCCESS';
export const GET_ALL_VERIFICATION_FAILURE = 'GET_ALL_VERIFICATION_FAILURE';

export const getAllVerification = () => {
  AppDispatcher.handleServerAction({
    actionType: GET_ALL_VERIFICATION,
  });
};

export const getAllVerificationSuccess = (response) => {
  AppDispatcher.handleServerAction({
    actionType: GET_ALL_VERIFICATION_SUCCESS,
    verificationList: response.verification_list,
  });
};

export const getAllVerificationFailure = (error) => {
  AppDispatcher.handleServerAction({
    actionType: GET_ALL_VERIFICATION_FAILURE,
    error,
  });
};
